import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Badge, BadgeTier, TIER_COLORS, TIER_FROM_LEVEL } from 'types/interfaces/badge';
import './BadgeTooltip.css';

interface BadgeTooltipProps {
  badge: Badge;
  earned: boolean;
  earnedAt?: string;
  position: { x: number; y: number };
}

const TOOLTIP_OFFSET = 12;
const TOOLTIP_WIDTH = 240;
const TOOLTIP_HEIGHT_ESTIMATE = 120;

const BadgeTooltip: React.FC<BadgeTooltipProps> = ({ badge, earned, earnedAt, position }) => {
  const [adjustedPos, setAdjustedPos] = useState(position);
  const tier: BadgeTier = TIER_FROM_LEVEL[badge.level] || 'bronze';
  const tierColor = TIER_COLORS[tier];

  useEffect(() => {
    const { innerWidth, innerHeight } = window;
    let x = position.x + TOOLTIP_OFFSET;
    let y = position.y + TOOLTIP_OFFSET;

    if (x + TOOLTIP_WIDTH > innerWidth) {
      x = position.x - TOOLTIP_WIDTH - TOOLTIP_OFFSET;
    }
    if (y + TOOLTIP_HEIGHT_ESTIMATE > innerHeight) {
      y = position.y - TOOLTIP_HEIGHT_ESTIMATE - TOOLTIP_OFFSET;
    }

    setAdjustedPos({ x, y });
  }, [position]);

  const formattedDate = earnedAt
    ? new Date(earnedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : null;

  return createPortal(
    <div
      className="badge-tooltip"
      style={{ left: adjustedPos.x, top: adjustedPos.y }}
    >
      <div className="badge-tooltip__title">{badge.title}</div>
      <div className="badge-tooltip__subtitle">{badge.subtitle}</div>
      <span
        className="badge-tooltip__tier"
        style={{ backgroundColor: tierColor, color: tier === 'gold' || tier === 'diamond' ? '#1a1a1a' : '#fff' }}
      >
        {tier.charAt(0).toUpperCase() + tier.slice(1)}
      </span>
      {earned && formattedDate && (
        <div className="badge-tooltip__earned">Earned {formattedDate}</div>
      )}
    </div>,
    document.body
  );
};

export default BadgeTooltip;
